<template>
  <div class="wrapper">
    <div class="wrapper-bg" />
    <div class="logo" />
    <div class="center d-flex justify-space-between align-start">
      <div
        class="slogan"
      >
        <div> 顾客<br>
          增长引擎欢迎您！
        </div>
        <div style="width: 256px; height: 8px; background: #fff; margin-top: 17px"/>
      </div>
      <div class="form">
        <div class="d-flex">
          <div
            class="title"
            :class="{active: loginType === loginTypes.password}"
            @click="changeLoginType(loginTypes.password)"
          >
            登录
          </div>
        </div>
        <div v-show="loginType === loginTypes.qrcode">
          <div
            style="margin-left: 42px; margin-top: -10px"
            id="qrcode"
          />
        </div>
        <div v-show="loginType === loginTypes.password">
          <a-form
            :form="form"
            :wrapper-col="{ span: 24 }"
          >
            <a-form-item>
              <a-input
                style="height: 48px; line-height: 48px"
                size="large"
                autocomplete="off"
                placeholder="请输入您的用户名"
                v-decorator="['userName',
                              { rules: [{ required: true, message: '请输入您的用户名!' }] }]"
              >
                <a-icon
                  style="font-size: 18px"
                  slot="prefix"
                  type="user"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                style="height: 48px; line-height: 48px"
                type="password"
                placeholder="请输入密码"
                size="large"
                v-decorator="['password',
                              { rules: [{ required: true, message: '请输入密码!' }] }]"
                @pressEnter="pressEnter"
              >
                <a-icon
                  style="font-size: 18px"
                  slot="prefix"
                  type="lock"
                />
              </a-input>
            </a-form-item>
          </a-form>
          <div style="marginTop: -15px; text-align: right">
            <div
              style="float:left;color:#ff4d4f;"
            >
              {{ errorHtml }}
            </div>
            <div
              class="login-form-forgot"
              @click="opentips"
            >
              忘记密码?
            </div>
          </div>
          <a-button
            type="primary"
            class="login-btn"
            @click="login"
          >
            登录
          </a-button>
          <a-button
            type="link"
            style="padding-left: 0; margin-top: 12px"
          >
            注册账号
          </a-button>
          <!-- <div
            class="qrcode-login"
            @click="workwechatLogin"
          >
            <img
              style="width: 24px; height: 24px"
              src="http://hh-oss-picture.miyapay.com/box/9a17f9d88722b26ac135a755ab17acfe.png"
            >
            <span>企业微信登录</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="copyright">
      Copyright @ {{ (new Date()).getFullYear() }} Hangzhou
      miya information technology co., LTD. All rights reserved
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { noop } from 'lodash';
import { goToFirstValidRoute } from '@/utils/helpers';
import { apiGetTenantContract } from '@/apis/user';

const loginTypes = {
  password: Symbol(),
  qrcode: Symbol(),
};

export default {
  data() {
    return {
      loginTypes,
      form: this.$form.createForm(this, { name: 'login' }),
      loginType: loginTypes.password,
    };
  },
  computed: {
    ...mapState('user', ['maxLoginTimes']),
    errorHtml() {
      const { maxLoginTimes } = this;
      if (maxLoginTimes < 1) {
        return '账号已经被锁定,请联系管理员解锁！';
      }
      return maxLoginTimes < 10 ? `密码错误，再错误${maxLoginTimes}次后将锁定账号` : '为了您的账号安全，请定期修改密码';
    },
  },
  mounted() {
    this.generateQrCode();
    this.clearContractInfo();
  },
  methods: {
    ...mapMutations(['updateContractInfo', 'clearContractInfo']),
    changeLoginType(type) {
      this.loginType = type;
    },
    generateQrCode() {
      window.WwLogin({
        id: 'qrcode',
        appid: 'ww7d7ebdd772bd9081',
        agentid: '1000022',
        redirect_uri: window.encodeURIComponent('http://dev.yuncha.miyapay.com/workwechat-callback'),
        state: '',
        href: 'https://hh-oss-html.miyapay.com/box/e727f28a24928419ffb100144d657922.css',
      });
    },
    async login() {
      try {
        const values = await this.form.validateFields();
        this.$store.dispatch('user/loginReq', values)
          .then(async () => {
            this.getTenantContract();
            goToFirstValidRoute(this.$router);
          })
          .catch(noop);
      } catch (err) {
        window.console.error(err);
      } finally {
        this.isLoggingIn = false;
      }
    },
    // 获取租户续约信息
    getTenantContract() {
      apiGetTenantContract().then((res) => {
        this.updateContractInfo(res || {});
      });
    },
    workwechatLogin() {
      window.location = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wx55dfad1998bda848&redirect_uri=${encodeURIComponent(`${window.location.origin}/workwechat-callback`)}&usertype=member`;
    },
    pressEnter() {
      this.login();
    },
    // 提示
    opentips() {
      this.$message.info('请联系您的客户经理');
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100vh;
  min-height: 700px;

  &-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(http://hh-oss-picture.miyapay.com/box/406cd5941f73e1cb469fa5f53306972e.png);
    background-size: 100% 100%;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background:linear-gradient(90deg,rgba(38,35,153,1) 0%,rgba(1,105,186,1) 100%);;
  }
}

.slogan {
  width: 512px;
  font-size: 64px;
  font-weight: 600;
  color: #fff;
  margin-top: 72px;
}

.logo {
  width: 182px;
  height: 32px;
  position: absolute;
  left: 40px;
  top: 24px;
  background: url(http://hh-oss-picture.miyapay.com/box/77d67bdce52bc9ae401d162b38c70eb5.png);
  background-size: 100% 100%;
}

.center {
  width: 1124px;
  height: 460px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.form {
  width:480px;
  height:460px;
  background:rgba(255,255,255,1);
  box-shadow:0px 8px 16px 0px rgba(0,0,0,0.12);
  border-radius:4px;
  padding: 48px;
  position: relative;

  .title {
    color: rgba(0,0,0,0.45);
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;
    margin-bottom: 35px;
    cursor: pointer;

    &.active {
      color: rgba(0,0,0,0.85);
      /* border-bottom: 4px solid #44C7D8; */
    }
  }

  .login-btn {
    width: 100%;
    margin-top: 15px;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    border: 0;
  }

  .login-form-forgot {
      float: right;
      font-size: 14px;
      color: #0091ff;
      line-height: 20px;
      cursor: pointer;
    }


  .qrcode-login {
    color: rgba(0,0,0,0.65);
    font-size: 14px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 22px;
    cursor: pointer;
  }
}

.copyright {
  position: absolute;
  width: 100%;
  height: 14px;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #fff;
  text-align: center;
}

.form .ant-input-lg {
  height: 48px !important;
  padding-left: 46px !important;
}

.form .ant-form-item {
  margin-bottom: 20px;
}
</style>
